































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import DxPopup from 'devextreme-vue/popup';
import { DxButton, DxScrollView, DxTextBox } from 'devextreme-vue';
import { DxCheckBox } from "devextreme-vue/check-box";
import DxContextMenu from 'devextreme-vue/context-menu';
import { alert } from 'devextreme/ui/dialog';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';

import TableGrid from '@/components/TableGrid/grid.vue';
import getGridInstance from "@/utils/grid-instance";
import DButton from '@/components/DButton/button.vue';
import DTagbox from '@/components/DTagbox/tagbox.vue';
import DSelectbox from "@/components/DSelectbox/selectbox.vue";

import notify_service from '@/services/notify_service';
import {
  YearType,
  CutType,
  PtnBuisnessPeriondType,
  EcoObjectType,
  ImportDiffObject, FilialNodeTreeExtended, FilialExtended
} from '@/services/models-service';
import YearService from '@/services/years-service';
import CutService from '@/services/cut-service';
import PtnBuisnessPeriodService from '@/services/ptn-buisness-period-service';
import DictCacheService from '@/services/dicts_cache_service';
import ShareService from '@/services/share-service';
import EcoObjectsService from '@/services/eco-objects-service';
import PtnImportService from '@/services/ptn-import-service';
import { setAlternatingRowsBackground, prettyCell } from '@/utils/excel';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import UserManagerService from "@/services/data/user_manager";
import UserAccessService from "@/services/user_access_service";
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import WebSocketService from '@/services/websocket_service';
import AnimatePopup from '@/components/AnimatePopup/animate-popup.vue';

@Component({
    name: 'Import',
    components: {
      DxButton,
      DxTextBox,
      TableGrid,
      DxScrollView,
      DButton,
      DTagbox,
      DSelectbox,
      DxCheckBox,
      DxPopup,
      DxContextMenu,
      DxLoadPanel,
      AnimatePopup
    }
})


export default class extends Vue {
  public shareService = ShareService;

  public ptnBuisnessPeriodService = PtnBuisnessPeriodService;
  public ptnImportService = PtnImportService;

  public current_year: string = '';
  public current_cut: any = '';

  public all_years: YearType [] = [];
  public cuts: CutType[] = [];
  public ptnCuts: PtnBuisnessPeriondType[] = [];

  public filial_ds: EcoObjectType [] = [];
  public all_filials_tree: any = {};
  public heat_node_ds: EcoObjectType [] = [];
  public facility_ds: EcoObjectType [] = [];
  public log_diff_ds: ImportDiffObject[] = [];

  public log_diff_title: string = 'Лог импорта';
  public show_log_table: boolean = false;

  public facilities_columns: any[] = [];
  public log_diff_columns: any[] = [];
  public selected_facilities: any[] = [];

  public heat_carriers = DictCacheService.heat_carrier;
  public logData: any = [];

  public filials: any = {};
  public nodes: any = {}

  public options: any[] = [];
  public permission_nodes: any[] = [];

  public params = {
    idMode: '',
    cut: null,
    ok_water: false,
    ok_steam: false,
    hn_water: false,
    hn_steam: false
  }

  public setting: any = {
    all_periods: false,
    months: {
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
      7: false,
      8: false,
      9: false,
      10: false,
      11: false,
      12: false
    },
    all_filials: false,
    filials: null,
    all_nodes: false,
    nodes: [],
    all_facilities: false,
    replace_accepted: false
  }

  public verification_summary = {
    show: false,
    diff: false,
    text: ''
  }

  public import_summary = {
    show: false,
    diff: false,
    text: ''
  }

  public prepare_excel: boolean = false;

  public update_total: boolean = false;
  public get importPopupOptions() {
    return {
      visible: this.update_total,
      text: 'Идёт импорт данных...'
    }
  }

    async created() {
      this.initColumns();

      this.all_years = YearService.filteredYearList;

      if (this.$options.sockets) {
        this.$options.sockets.onmessage = async (data: any) => {
          let res = WebSocketService.handleMsg(data, 'update_total_rows');
          if (!_.isNil(res)) {
            if (!res.success && res.message) {
              notify_service.error(res.message)
            }

            this.update_total = false;
          }
        }
      }

      try {
        const resp = await this.ptnBuisnessPeriodService.get();
        console.log(resp)
        if (resp?.data) {
          this.ptnCuts = resp.data;
        } else {
          notify_service.error(resp?.message || 'Ошибка загрузки срезок АРМ ПТН')
        }

      } catch (e) {
        notify_service.error('Ошибка загрузки срезок АРМ ПТН')
      }
    }

    async mounted() {
      this.options = [
        {text: "Выбрать квартал"}
        ];

      let route = this.$route.name
      if(route) {
        this.permission_nodes = UserAccessService.checkReading(route);
      }
    }

  async onShowing() {
    let commonSettings:any = localStorage.getItem('importPopupSettings');
    commonSettings = JSON.parse(commonSettings);
    if (commonSettings) {
      this.current_year = commonSettings.current_year || null;
      if (commonSettings.setting) {
        this.setting = commonSettings.setting;
      }
      if (commonSettings.params) {
        this.params = commonSettings.params;
      }
      this.appointCurrentCut(commonSettings.current_cut);

      this.getFilials();
    }

  }

    initColumns() {

      this.facilities_columns = [{
        dataField: "id",
        dataType: "string",
        visible: false,
      },

        {
          dataField: "filial_name",
          dataType: "string",
          caption: "Филиал",
        },
        {
          dataField: "parent_name",
          dataType: "string",
          caption: "Теловой узел",
        },
        {
          dataField: "name",
          dataType: "string",
          caption: "Объект генерации",
        },
      ];

      this.log_diff_columns = [{
        dataField: "id",
        dataType: "string",
        visible: false,
      },

        {
          dataField: "filial_name",
          dataType: "string",
          caption: "Филиал",
        },
        {
          dataField: "parent_name",
          dataType: "string",
          caption: "Теловой узел",
        },
        {
          dataField: "name",
          dataType: "string",
          caption: "Объект генерации",
        },
        {
          dataField: "month_rus",
          dataType: "string",
          caption: "Месяц",
        },
        {
          dataField: "block",
          dataType: "string",
          caption: "Блок",
          calculateCellValue: this.calculateBlock,
        },
        {
          dataField: "id_heat_carrier",
          caption: "Вид ТЭ",
          dataType: "string",
          calculateCellValue: this.calculateHeatCarrierDisplay
        },
        {
          dataField: "value_db",
          dataType: "number",
          format: "number",
          caption: "Объем (форма тепла)",
        },
        {
          dataField: "value_import",
          dataType: "number",
          format: "number",
          caption: "Объем (АРМ ПТН)",
        },
        {
          name: "value_difference",
          dataType: "number",
          format: "number",
          caption: "откл",
          calculateCellValue: this.calcValueDifference,
          width: '1px',
          visible: false,
        },
      ];

    }

  private calcValueDifference(data: any): number | null {
    if (_.isNil(data.value_db) && _.isNil(data.value_import)) {
      return null
    }
    return Math.abs((data.value_import || 0) - (data.value_db || 0));
  }

  private async downloadLog() {
    this.prepare_excel = true;
    this.$forceUpdate();

    setTimeout(async () => {
      const workbook = new Workbook();
      const workSheet = workbook.addWorksheet('Sheet1');

      const calculateDiffCellColor = (gridCell: any, excelCell: any) => {
        if (gridCell.rowType !== 'data') {
          return;
        }
        if (gridCell.data.accepted) {
          const cellColor = (excelCell.fullAddress.row % 2 === 0) ? '707070' : '909090';
          prettyCell(excelCell, { cellColor, fontColor: 'FFFFFF' })
        } else if (gridCell.data.diff &&
          ['value_import', 'value_db', 'value_difference'].includes(gridCell.column.name )) {
          // Раскрасить ячейки с несовпадением значений импорта
          const cellColor = (excelCell.fullAddress.row % 2 === 0) ? '9F0021' : 'C10432';
          prettyCell(excelCell, { cellColor, fontColor: 'FFFFFF' })
        }
      }

      // скачать excel лога
      const exportLogGrid = getGridInstance(this.$refs.logDiffGrid);
      const cutItem = this.cuts.find( c => c.id === this.current_cut);
      const yearItem = this.all_years.find( y => y.id === this.current_year);
      exportLogGrid.columnOption("value_difference", "visible", true);
      if (exportLogGrid && cutItem ) {
        await exportDataGrid({
          worksheet: workSheet,
          component: exportLogGrid,
          topLeftCell: { row: 2, column: 2 },
          customizeCell: ({ gridCell, excelCell }) => {
            setAlternatingRowsBackground(gridCell, excelCell, 7);
            calculateDiffCellColor(gridCell, excelCell);
          },
        });
        // Последний Столбец отклонений значений не показывется в окне программы, но показывать в экспортируемой таблице
        // поэтому задаём его как скрытый шириной в 1px и устанавливаем флаг видимости только на момент экспорта в Excel
        exportLogGrid.columnOption("value_difference", "visible", false);
        const diffColIndex = workSheet.columns.length - 1;
        // Ширина столбца отклонения устанавливается в зависимости от ширины столбцов сравниваемых данных
        workSheet.columns[diffColIndex].width = Math.max(
          workSheet.columns[diffColIndex - 1].width || 10, workSheet.columns[diffColIndex - 2].width || 10)

        workbook.xlsx.writeBuffer().then((buffer) => {
          this.prepare_excel = false;
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }),
            `Лог_верификации_${cutItem.name.replace(' ', '_')}_${yearItem?.name || ''}.xlsx`);
        });
      }
    }, 500);

  }

  calculateBlock(rowData: any): string {
    let res = '';
    if (rowData.block === 'ok') {
      res = 'ОК'
    }
    else if (rowData.block === 'hn') {
      res = 'ХН'
    }
    return res;
  }

  calculateHeatCarrierDisplay(rowData: any): string {
    if (_.isNil(rowData.id_heat_carrier)) {
      return '';
    }
    const carrier = this.heat_carriers.find((hc: any) => hc.id == rowData.id_heat_carrier);
    return carrier ? carrier.name : String(rowData.id_heat_carrier);
  }

  private customizeCell(e: any) {
    if (e.rowType !== 'data') {
      return;
    }

    if (e.columnIndex === 6 || e.columnIndex === 7) {
      if (e.data.diff) {
        e.cellElement.classList.add('status-cell_diff');
        if (!(e.rowIndex % 2)) {
          // Для подсвеченных ячеек более светлой строки другой оттенок красного
          e.cellElement.classList.add('status-cell_diff_odd');
        }
      }
    }

  }

  private customizeRow(e: any) {
    if (e.rowType !== 'data') {
      return;
    }
    if (e.data.accepted) {
      e.rowElement.classList.add('status-row_accept');
      if (!(e.rowIndex % 2)) {
        // Для подсвеченных ячеек более светлой строки другой оттенок
        e.rowElement.classList.add('status-row_accept_odd');
      }
    }
  }

    selectFirstQuarter(e: any) {
      if (e.itemData.text === "Выбрать квартал") {
        if (this.setting.months['1'] && this.setting.months['2'] && this.setting.months['3']) {
          this.setting.months['1'] = this.setting.months['2'] = this.setting.months['3'] = false;
        } else {
          this.setting.months['1'] = this.setting.months['2'] = this.setting.months['3'] = true;
        }
      }
    }

    selectTwoQuarter(e:any) {
      if (e.itemData.text === "Выбрать квартал") {
        if (this.setting.months['4'] && this.setting.months['5'] && this.setting.months['6']) {
          this.setting.months['4'] = this.setting.months['5'] = this.setting.months['6'] = false;
        } else {
          this.setting.months['4'] = this.setting.months['5'] = this.setting.months['6'] = true;
        }
      }
    }

    selectThereeQuarter(e:any) {
      if (e.itemData.text === "Выбрать квартал") {
        if (this.setting.months['7'] && this.setting.months['8'] && this.setting.months['9']) {
          this.setting.months['7'] = this.setting.months['8'] = this.setting.months['9'] = false;
        } else {
          this.setting.months['7'] = this.setting.months['8'] = this.setting.months['9'] = true;
        }
      }
    }

    selectFourQuarter(e:any) {
      if (e.itemData.text === "Выбрать квартал") {
        if (this.setting.months['10'] && this.setting.months['11'] && this.setting.months['12']) {
          this.setting.months['10'] = this.setting.months['11'] = this.setting.months['12'] = false;
        } else {
          this.setting.months['10'] = this.setting.months['11'] = this.setting.months['12'] = true;
        }
      }
    }

    get selectedMonths(): number[] {
      let months = [];
      for (const [key, value] of Object.entries(this.setting.months)) {
          if (value) {
            months.push(Number(key));
          }
      }
      return months;
    }



  async getFilials() {

    this.setting.filials = [];
    this.setting.nodes = [];
    this.heat_node_ds = [];
    this.filial_ds = [];

      if (!this.current_cut || !this.current_year) {
        return
      }

    const year = this.all_years.find((y: YearType) => y.id === this.current_year);
    const cut = this.cuts.find((c: CutType) => c.id === this.current_cut);

    if (!year || !cut) {
      return
    }

    let filials_ids = new Set();
    for (let key in UserAccessService.userAccessDS) {
      filials_ids.add(key)
    }

    this.all_filials_tree = {};
    const response = await EcoObjectsService.filial_nodes_tree_extended(cut.id_eco_version, year.name, null);

    if (response?.data) {

      const filials_tree: FilialNodeTreeExtended = _.cloneDeep(response.data);

      for (let filial_uid in filials_tree) {
        const filial: FilialExtended = filials_tree[Number(filial_uid)];
        const filial_id: string = `${filial.filial.id}`;
        if (!filials_ids.has(filial_id)) {
          continue
        }

        this.filial_ds.push(filial.filial);
        this.all_filials_tree[filial_id] = [];
        for (let node_uid in filial.nodes) {
          const node = filial.nodes[Number(node_uid)];
          this.all_filials_tree[filial_id].push(node)
        }
      }
    }

  }

  @Watch('setting.filials', { deep: true })
  @Watch('setting.all_filials')
  async changeFilial() {

    await this.getNodes();
  }


  async getNodes() {

    this.heat_node_ds = [];
    this.setting.nodes = [];
    let nodeIds = new Set();
    let nodes = [];

    if (this.setting.all_filials) {
      // выбраны все филиалы
      for (let filial_id of Object.keys(this.all_filials_tree)) {
        if (this.all_filials_tree[filial_id].length === 0) {
          continue
        }

        for (let n of this.all_filials_tree[filial_id]) {
          if (nodeIds.has(n.id) || !this.permission_nodes.includes(n.id)) {
            continue
          }
          nodeIds.add(n.id);
          nodes.push(n)
        }
        this.heat_node_ds = _.cloneDeep(nodes);
      }

    } else if (this.setting.filials) {
      // выбрана часть филиалов
      if (this.setting.filials.length === 0) {
        return
      }

      for (let filial_id of this.setting.filials) {
        if (this.all_filials_tree[filial_id].length === 0) {
          continue
        }

        for (let n of this.all_filials_tree[filial_id]) {
          if (nodeIds.has(n.id) || !this.permission_nodes.includes(n.id)) {
            continue
          }
          nodeIds.add(n.id);
          nodes.push(n)
        }
      }

      this.heat_node_ds = _.cloneDeep(nodes);
    }
  }

  @Watch("current_year")
  changeYear() {
    this.getCutsYear();
    this.current_cut= '';
    this.getFilials();
  }

  @Watch('current_year')
  @Watch('current_cut')
  @Watch('setting.nodes')
  @Watch('setting.all_nodes')
  @Watch('setting.all_periods')
  @Watch('setting.all_periods')
  @Watch('setting.months', {deep: true})
  async changeParams() {
    if (this.facility_ds.length > 0) {
      this.facility_ds = [];
    }

  }

  @Watch('current_year')
  @Watch('current_cut')
  @Watch('setting.nodes')
  @Watch('setting.all_nodes')
  @Watch('setting.all_periods')
  @Watch('setting.all_periods')
  @Watch('setting.months', {deep: true})
  @Watch('params', {deep: true})
  @Watch('selected_facilities')
  async changeImportParams() {
    this.show_log_table = false;
    if (this.log_diff_ds.length > 0) {
      this.log_diff_ds = [];
    }
  }

  @Watch("current_cut")
  changeCut() {
    this.getFilials();
  }


  validateParams() {
    let strer = '';
    if (!this.current_year) {
      strer += `Не выбран год<br>\n`
    }

    if (!this.current_cut) {
      strer += `Не выбрана срезка<br>\n`
    }

    if (this.selectedMonths.length === 0 && !this.setting.all_periods) {
      strer += `Не выбраны месяцы<br>\n`
    }

    if (((!this.setting.filials || this.setting.filials.length === 0) && !this.setting.all_filials) ||
      ((!this.setting.nodes || this.setting.nodes.length === 0) && !this.setting.all_nodes)) {
      strer += `Не выбраны тепловые узлы<br>\n`
    }

    return strer;
  }

  async getFacilities() {

    const validate_errors = this.validateParams();
    if (validate_errors.length > 0) {
      await alert(validate_errors, 'Не выбраны параметры');
      return
    }

    this.selected_facilities = [];
    this.facility_ds = [];

    const resp = await this.ptnImportService.get_gen_object_list(this.current_year, this.current_cut, this.selectedMonths,
      this.setting.all_filials, this.setting.filials, this.setting.all_nodes, this.setting.nodes);

    if (resp?.data) {
      this.facility_ds = resp.data;
    }

    this.saveLastParams();

  }

    async getCutsYear() {
      const response = await CutService.getWithFilter(this.current_year);
      if (response.data) {
        this.cuts = response.data;
        this.cuts.sort((a: any, b: any) => a.date_created - b.date_created)
      }
    }

    appointCurrentCut(cut: string) {
      if (!cut) {
        return
      }

      if (this.cuts?.length > 0) {
        this.current_cut = cut;
      } else {
        setTimeout(() => this.appointCurrentCut(cut), 500);
      }
    }

    get blocksList() {
      let blocks = [];
      if (this.params.ok_steam) {
        blocks.push('ok_steam')
      }
      if (this.params.ok_water) {
        blocks.push('ok_water')
      }
      if (this.params.hn_steam) {
        blocks.push('hn_steam')
      }
      if (this.params.hn_water) {
        blocks.push('hn_water')
      }
      return blocks;
    }

    get selectedObjectsList() {
      let result: any[] = [];

      this.selected_facilities.forEach((obj_id: number) => {
        let obj = this.facility_ds.find((f: any) => f.id === obj_id);
        if (obj) {
          obj.date_from = null;
          obj.date_to = null;
          obj.relation_from = null;
          obj.relation_to = null;
          result.push(obj)
        }
      })

      return result;
    }

    validateImportFilter() {
      let strer = '';
      if (!this.current_year) {
        strer += `Не выбран год<br>\n`
      }

      if (!this.current_cut) {
        strer += `Не выбрана срезка<br>\n`
      }

      if (this.selectedMonths.length === 0 && !this.setting.all_periods) {
        strer += `Не выбраны месяцы<br>\n`
      }

      if (((!this.setting.filials || this.setting.filials.length === 0) && !this.setting.all_filials) ||
        ((!this.setting.nodes || this.setting.nodes.length === 0) && !this.setting.all_nodes)) {
        strer += `Не выбраны тепловые узлы<br>\n`
      }

      if (this.selectedObjectsList.length === 0) {
        strer += `Не выбраны объекты<br>\n`
      }

      if (!this.params.cut || this.blocksList.length === 0) {
        strer += `Не выбраны параметры импорта<br>\n`
      }


      return strer;
    }

    async verifyData() {

      const validate_errors = this.validateImportFilter();
      if (validate_errors.length > 0) {
        await alert(validate_errors, 'Не выбраны параметры');
        return
      }

      this.show_log_table = false;

        let filter = {
          year_id: this.current_year,
          cut_id: this.current_cut,
          months: this.selectedMonths,
          business_period_id: this.params.cut,
          objects: this.selectedObjectsList,
          blocks: this.blocksList,
        }

      const resp = await this.ptnImportService.verify(filter);

      if (resp?.data) {
        this.log_diff_ds = resp.data;
        this.log_diff_title = 'Результаты верификации'
        this.show_log_table = true;

        if (this.log_diff_ds.length > 0) {

          let diff = _.some(this.log_diff_ds, { 'diff': true });

          if (diff) {
            this.verification_summary.diff = true;
            this.verification_summary.text = 'Есть расхождения в данных';
            this.import_summary.show = false;
            this.verification_summary.show = true;
          } else {
            this.verification_summary.diff = false;
            this.verification_summary.text = 'Данные совпадают';
            this.import_summary.show = false;
            this.verification_summary.show = true;
          }
        } else {
          this.verification_summary.show = false;
        }

      } else {
        this.log_diff_ds = [];
        this.verification_summary.show = false;
        this.verification_summary.diff = false;
        this.verification_summary.text = '';
      }

    }


  async importData() {

    const validate_errors = this.validateImportFilter();
    if (validate_errors.length > 0) {
      await alert(validate_errors, 'Не выбраны параметры');
      return
    }
    this.update_total = true;

    let filter = {
      year_id: this.current_year,
      cut_id: this.current_cut,
      months: this.selectedMonths,
      business_period_id: this.params.cut,
      objects: this.selectedObjectsList,
      blocks: this.blocksList,
      replace_accepted: this.setting.replace_accepted,
    }

    const resp = await this.ptnImportService.import_data(filter);

    if (resp) {
      if (resp?.data) {
        this.log_diff_ds = resp.data;
      } else {
        this.log_diff_ds = [];
      }

      this.log_diff_title = 'Лог импорта'
      this.show_log_table = true;

      this.import_summary.text = `Импортировано записей: ${this.log_diff_ds.length} `;
      this.verification_summary.show = false;
      this.import_summary.show = true;

    }
  }

    onClose() {
      this.saveLastParams();
      this.shareService.closeImportPopup();
      if (this.$options.sockets) {
        delete this.$options.sockets.onmessage;
      }
    }

    saveLastParams() {
      let commonSettings: any = {};
      commonSettings.current_year = this.current_year;
      commonSettings.current_cut = this.current_cut;
      commonSettings.setting = this.setting;
      commonSettings.params = this.params;
      commonSettings = JSON.stringify(commonSettings);
      localStorage.setItem('importPopupSettings', commonSettings)
    }

    chooseAllPeriods() {
      if (this.setting.all_periods) {
        for (let i=1; i<=12; i++) {
          this.setting.months[i.toString()] = true
        }
      } else {
        for (let i=1; i<=12; i++) {
          this.setting.months[i.toString()] = false
        }
      }
    }

    chooseAllFilials() {
      if (this.setting.all_filials) {
        this.setting.filials = [];
      }
    }

    chooseAllNodes() {
      if (this.setting.all_nodes) {
        this.setting.nodes = [];

      }
    }

    empty() {
        //
    }

}
